<template>
<table cellpadding="0" cellspacing="0" :class="disable?'table-date-disable':'table-date'">
    <tr class="date-tr">
        <td width="100" class="time-first-td">
            <input ref="yearInput" @blur="yearBlur($event)" @keyup="yearValue=yearValue.toString().replace(/[^0-9]/g,'');" @afterpaste="yearValue=yearValue.replace(/[^0-9]/g,'');" type="text" class="date-value-width" name="YY" v-model="yearValue" @click.stop="yearValueClick($event)" :class="[checkYear?'time-checked':'',disable?numberDisableClass:'time-input']" @change="checkDateValue()" maxlength="4" v-bind:disabled="disable" />
            <input type="text" class="time-icon-width" readonly="true" value="/" :class="[disable?'time-input-disabled':'time-input']" />
            <input ref="monthInput" @blur="monthBlur($event)" @keyup="monthValue=monthValue.toString().replace(/[^0-9]/g,'');" @afterpaste="monthValue=monthValue.replace(/[^0-9]/g,'');" type="text" class="time-value-width" name="MM" v-model="monthValue" @click.stop="monthValueClick($event)" :class="[disable?numberDisableClass:'time-input']" @change="checkDateValue()" maxlength="2" v-bind:disabled="disable" />
            <input type="text" class="time-icon-width" readonly="true" value="/" :class="[disable?'time-input-disabled':'time-input']" />
            <input ref="dayInput" @blur="dayBlur($event)" @keyup="dayValue=dayValue.toString().replace(/[^0-9]/g,'');" @afterpaste="dayValue=dayValue.replace(/[^0-9]/g,'');" type="text" class="time-input time-value-width" name="DD" v-model="dayValue" @click.stop="dateValueClick($event)" :class="[checkDay?'time-checked':'',disable?numberDisableClass:'time-input']" @change="checkDateValue()" maxlength="2" v-bind:disabled="disable" />
        </td>
        <td width="20" class="time-second-td">
            <input type="button" hidefocus="true" class="time-buton icon-util" @click.stop="add()" @mousedown="startTimer('add')" @mouseup="endTimer()" @mouseleave="endTimer()" v-bind:disabled="disable" :class="[disable?disableUpClass:'time-drop-down-up']" />
            <input type="button" hidefocus="true" class="time-buton icon-util" @click.stop="subtract()" @mousedown="startTimer('')" @mouseup="endTimer()" @mouseleave="endTimer()" v-bind:disabled="disable" :class="[disable?disableDownClass:'time-drop-down']" />
        </td>
    </tr>
</table>
</template>

<script>
import "@/assets/css/time_selector.css";
export default {
    props: ["disable", "scheduleFlage"],
    data: function () {
        return {
            yearValue: null,
            monthValue: null,
            dayValue: 18,
            checkYear: false,
            checkMonth: false,
            checkDay: false,
            timer: null,
            intervalTimer: null,
            disableDownClass: " down-narrow",
            disableUpClass: " up-narrow",
            numberDisableClass: "time-input-disabled",
            dateValue: null
        };
    },
    created() {
        this.yearValue = new Date().getFullYear();
        this.monthValue = new Date().getMonth() + 1;
        this.dayValue = new Date().getDate();
        this.monthValue = this.monthValue < 10 ? ('0' + this.monthValue) : this.monthValue;
        this.dayValue = this.dayValue < 10 ? ('0' + this.dayValue) : this.dayValue;
        this.dateValue = this.yearValue + '-' + this.monthValue + '-' + this.dayValue;
        this.$emit('changeDate', this.dateValue);
    },
    watch: {
        dateValue(newName, oldName) {
            this.$emit('changeDate', newName);
        }
    },
    methods: {
        yearBlur(event) {
            if (this.checkYear) {
                event.currentTarget.select();
            }
        },
        monthBlur(event) {
            this.checkMonthNum();
            if (this.checkMonth) {
                event.currentTarget.select();
            }
        },
        dayBlur(event) {
            this.checkDayNum();
            if (this.checkDay) {
                event.currentTarget.select();
            }
        },
        yearValueClick(event) {
            let that = this;
            if (!that.checkYear && !that.checkMonth && !that.checkDay) {
                if (that.$parent.minDate) {
                    that.$parent.reSet();
                } else {
                    that.$parent.$parent.$parent.$parent.reSet();
                }
            }
            setTimeout(function () {
                that.checkYear = true;
                that.checkMonth = false;
                that.checkDay = false;
                that.$refs.yearInput.select();
            }, 100);
        },
        monthValueClick(event) {
            let that = this;
            if (!that.checkYear && !that.checkMonth && !that.checkDay) {
                if (that.$parent.minDate) {
                    that.$parent.reSet();
                } else {
                    that.$parent.$parent.$parent.$parent.reSet();
                }
            }
            setTimeout(function () {
                that.checkYear = false;
                that.checkMonth = true;
                that.checkDay = false;
                that.$refs.monthInput.select();
            }, 100);
        },
        dateValueClick(event) {
            let that = this;
            if (!that.checkYear && !that.checkMonth && !that.checkDay) {
                if (that.$parent.minDate) {
                    that.$parent.reSet();
                } else {
                    that.$parent.$parent.$parent.$parent.reSet();
                }
            }
            setTimeout(function () {
                that.checkYear = false;
                that.checkMonth = false;
                that.checkDay = true;
                that.$refs.dayInput.select();
            }, 100);
        },
        checkDateValue() {
            if (parseInt(this.dayValue) < 1) {
                this.monthValue = parseInt(this.monthValue) - 1;
            }
            this.checkYearNum();
            this.checkMonthNum();
            this.checkDayNum();
            this.dateValue = this.yearValue + '-' + this.monthValue + '-' + this.dayValue;
        },
        checkYearNum() {
            let tYear = new Date().getFullYear();
            if (this.scheduleFlage) {
                if (this.yearValue < tYear) {
                    this.yearValue = tYear;
                }
            }
            this.dateValue = this.yearValue + '-' + this.monthValue + '-' + this.dayValue;
        },
        checkMonthNum() {
            if (this.monthValue > 12) {
                this.monthValue = 1;
                this.yearValue = this.yearValue + 1;
            }
            if (this.monthValue < 1) {
                this.monthValue = 12;
                this.yearValue = this.yearValue - 1;
            }
            if (this.scheduleFlage) {
                let tYear = new Date().getFullYear();
                let tmonth = new Date().getMonth() + 1;
                if (this.yearValue <= tYear && this.monthValue < tmonth) {
                    this.monthValue = tmonth;
                }
            }
            if (parseInt(this.monthValue) < 10) {
                this.monthValue = '0' + parseInt(this.monthValue);
            }
            if (parseInt(this.dayValue) < 10) {
                this.dayValue = '0' + parseInt(this.dayValue);
            }
            this.dateValue = this.yearValue + '-' + this.monthValue + '-' + this.dayValue;
        },
        checkDayNum() {
            if (
                this.monthValue == 1 ||
                this.monthValue == 3 ||
                this.monthValue == 5 ||
                this.monthValue == 7 ||
                this.monthValue == 8 ||
                this.monthValue == 10 ||
                this.monthValue == 12
            ) {
                if (parseInt(this.dayValue) > 31) {
                    if (this.dayValue == 32) {
                        this.monthValue = parseInt(this.monthValue) + 1;
                    }
                    this.dayValue = 1;
                }
                if (parseInt(this.dayValue) < 1) {
                    //  this.monthValue = parseInt(this.monthValue) - 1;
                    //对2月份进行特殊处理
                    if (parseInt(this.monthValue) == 2) {
                        if (this.isRun(parseInt(this.yearValue))) {
                            this.dayValue = 29;
                        } else {
                            this.dayValue = 28;
                        }
                    } else {
                        this.dayValue = 31;
                    }
                }
            } else {
                //若月份不是二月
                if (parseInt(this.monthValue) != 2) {
                    if (this.dayValue > 30) {
                        if (this.dayValue == 31) {
                            this.monthValue = parseInt(this.monthValue) + 1;
                        }
                        this.dayValue = 1;
                    }
                    if (this.dayValue < 1) {
                        this.dayValue = 30;
                        // this.monthValue = parseInt(this.monthValue) - 1;
                    }
                }
                this.checkFebruaryDay();

            }
            if (this.scheduleFlage) {
                let tYear = new Date().getFullYear();
                let tdate = new Date().getDate();
                let tMonth = new Date().getMonth() + 1;
                if (this.yearValue <= tYear && this.dayValue < tdate && this.monthValue <= tMonth) {
                    this.dayValue = tdate;
                }

            }
            if (parseInt(this.dayValue) < 10) {
                this.dayValue = '0' + parseInt(this.dayValue);
            }
            if (parseInt(this.monthValue) < 10) {
                this.monthValue = '0' + parseInt(this.monthValue);
            }
            this.dateValue = this.yearValue + '-' + this.monthValue + '-' + this.dayValue;
        },
        //检测2月份的日期
        checkFebruaryDay() {
            //若月份是二月
            if (this.monthValue == 2) {
                //如果是闰年 29天
                if (this.isRun(this.yearValue)) {
                    if (this.dayValue > 29) {
                        if (this.dayValue == 30) {
                            this.monthValue = parseInt(this.monthValue) + 1;
                        }
                        this.dayValue = 1;
                    }
                    //如果不是闰年 28天  
                } else {
                    if (this.dayValue > 28) {
                        if (this.dayValue == 29) {
                            this.monthValue = parseInt(this.monthValue) + 1;
                        }
                        this.dayValue = 1;
                    }

                }
                if (this.dayValue < 1) {
                    this.dayValue = 31;
                    this.monthValue = parseInt(this.monthValue) - 1;
                }
            }
        },
        //判断该年是否是闰年，根据是否是闰年判断2月份的天数
        isRun(year) {
            var flag = false;
            if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
                flag = true;
            }
            return flag;
        },
        add() {
            let that = this;
            setTimeout(function () {
                if (that.checkYear) {
                    that.yearValue++;
                    that.checkDateValue();
                    that.$nextTick(function () {
                        that.$refs.yearInput.select();
                    });
                } else if (that.checkMonth) {
                    that.monthValue++;
                    that.checkDateValue();
                    that.$nextTick(function () {
                        that.$refs.monthInput.select();
                    });
                } else if (that.checkDay) {
                    that.dayValue++;
                    that.checkDateValue();
                    that.$nextTick(function () {
                        that.$refs.dayInput.select();
                    })
                } else if (!that.checkYear && !that.checkMonth && !that.checkDay) {
                    if (that.$parent.minDate) {
                        that.$parent.reSet();
                    } else {
                        that.$parent.$parent.$parent.$parent.reSet();
                    }
                    that.dayValue++;
                    that.checkDateValue();
                    that.checkDay = true;
                    that.$nextTick(function () {
                        that.$refs.dayInput.select();
                    })
                }
            }, 100);

        },
        subtract() {
            let that = this;
            setTimeout(function () {
                if (that.checkYear) {
                    that.yearValue--;
                    that.checkDateValue();
                    that.$nextTick(function () {
                        that.$refs.yearInput.select();
                    });
                }
                if (that.checkMonth) {
                    that.monthValue--;
                    that.checkDateValue();
                    that.$nextTick(function () {
                        that.$refs.monthInput.select();
                    })
                }
                if (that.checkDay) {
                    that.dayValue--;
                    that.checkDateValue();
                    that.$nextTick(function () {
                        that.$refs.dayInput.select();
                    })
                } else if (!that.checkYear && !that.checkMonth && !that.checkDay) {
                    if (that.$parent.minDate) {
                        that.$parent.reSet();
                    } else {
                        that.$parent.$parent.$parent.$parent.reSet();
                    }
                    that.dayValue--;
                    that.checkDateValue();
                    that.checkDay = true;
                    that.$nextTick(function () {
                        that.$refs.dayInput.select();
                    })
                }
            }, 500);

        },
        startTimer(flag) {
            this.timer = setTimeout(() => {
                this.intervalTimer = setInterval(() => {
                    if (flag == "add") {
                        this.add();
                    } else {
                        this.subtract();
                    }
                }, 200);
            }, 1000);
        },
        endTimer() {
            clearTimeout(this.timer);
            this.timer = null;
            clearTimeout(this.intervalTimer);
            this.intervalTimer = null;
        }
    }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/selector/date_selector.vue